import { usePageTitle } from "@/hooks/usePageTitle";

/**
 * The one `document.title` writer (ENG-APP-UX-TUNEUP Track A, floor row 1).
 *
 * Rendered once in `App.tsx` as the first child of the router, above every
 * route tree — the public auth pages, the admin pages and the authenticated
 * shell all pass through it — so no route can render the bare wordmark.
 * Renders nothing.
 */
export default function PageTitleSync(): null {
  usePageTitle();
  return null;
}
